/* eslint-disable */
import { inject, Injectable, signal, WritableSignal } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";
import { Observable, Subject, Subscription, tap } from "rxjs";
import {
  IRegion,
  IRegionData,
} from "@modules/geography/models/regions.interface";
import { IDistrict } from "@modules/geography/models/districts.interface";
import removeEmptyProperties from "@shared/utils/removeEmptyProperties";
import { IRowNode } from "ag-grid-community";

@Injectable({
  providedIn: "root",
})
export class GlobalService<T, Ti, Tu> {
  _http = inject(HttpClient);
  _api = environment.apiUrl;
  protected _apiUrl = environment.apiUrl;
  subscriptions = new Subscription();
  reloadDataTable = new Subject<boolean>();
  readonly selectedItems = signal<IRowNode | any>([]);

  regions: WritableSignal<IRegion[]> = signal([]);
  districts: WritableSignal<IDistrict[]> = signal([]);

  getRegions(): IRegion[] | undefined {
    if (this.regions().length) {
      return this.regions();
    }
    this.subscriptions = this._http
      .get<IRegionData>(`${this._api}user-service/regions`)
      .subscribe({
        next: (res) => {
          this.regions.set(res.content);
          this.subscriptions.unsubscribe();
          return res.content;
        },
        error: (err) => {
          console.log(err);
          this.subscriptions.unsubscribe();
          return [];
        },
      });
  }

  getAll<T>(): Observable<T> {
    return this._http.get<T>(this._api);
  }

  getOne<Tu>(id: number, params?: string): Observable<Tu> {
    const extraParams = params ? params : "";

    return this._http.get<Tu>(
      this._api + "/" + id + "?include=translates" + extraParams
    );
  }

  getByFilter<T>(filter: any) {
    let data = removeEmptyProperties(filter);
    data = new URLSearchParams(data).toString();
    return this._http.get<T>(this._api + "?" + data);
  }

  getByFilterAdditionalInformation<T>(filter: any, reportType: string) {
    let data = removeEmptyProperties(filter);
    data = new URLSearchParams(data).toString();
    return this._http.get<T>(this._api + "/" + reportType + "?" + data);
  }

  insert<Ti>(form: Ti) {
    return this._http
      .post<Ti>(this._api, form)
      .pipe(tap(() => this.loadDataTable()));
  }

  delete(id: number) {
    return this._http
      .delete(this._api + "/" + id)
      .pipe(tap(() => this.loadDataTable()));
  }

  multipleDelete() {
    return this._http
      .delete(this._api, {
        params: {
          ids: this.selectedItems()
            .map(({ id }: { id: string | number }) => id)
            .join(","),
        },
      })
      .pipe(tap(() => this.loadDataTable()));
  }

  update(form: Tu | any) {
    return this._http
      .put(this._api + "/" + form!.id, form)
      .pipe(tap(() => this.loadDataTable()));
  }

  patch(form: any) {
    return this._http
      .patch(this._api + "/" + form!.id, form)
      .pipe(tap(() => this.loadDataTable()));
  }

  multipleUpdate(data: any) {
    return this._http
      .patch(this._api, data)
      .pipe(tap(() => this.loadDataTable()));
  }

  customUpdate(data: any) {
    return this._http
      .put(this._api, data)
      .pipe(tap(() => this.loadDataTable()));
  }

  loadDataTable() {
    this.reloadDataTable.next(true);
  }
}
